import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import React, {useState} from "react";
import {IoAdd, IoCloseCircle} from "react-icons/io5";
import styled from "styled-components";

const StyledAddCategoryModal = styled.div`
    width: 100%;
    .input-field-wrap {
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
    }
    .label {
        font-size: 18px;
        line-height: 22px;
        font-weight: 400;
        margin-bottom: 15px;
    }
    .tabs-wrap {
        list-style: none;
        display: flex;
        gap: 15px;
        margin-bottom: 20px;
        li {
            border: 1px solid rgba(205, 205, 205, 1);
            border-radius: 30px;
            padding: 5px 10px;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            cursor: pointer;
            &.active {
                color: var(--primary);
                border-color: rgba(245, 126, 42, 0.15);
                background-color: rgba(245, 126, 42, 0.15);
            }
        }
    }

    .item-form {
        margin-bottom: 20px;
        .input-field-wrap {
            margin-bottom: 20px;
        }
        @media (min-width: 576px) {
            display: flex;
            align-items: flex-end;
            gap: 13px;
            .input-field-wrap {
                margin-bottom: 0;
            }
        }
    }
    .title {
        display: block;
        color: rgba(143, 143, 143, 1);
        font-size: 18px;
        line-height: 22px;
        font-weight: 400;
        margin-bottom: 17px;
    }
    .items-list {
        list-style: none;
        li {
            padding: 20px;
            border: 1px solid rgba(205, 205, 205, 1);
            border-radius: 48px;
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 15px;
        }
    }
    .btn-holder {
        display: flex;
        justify-content: center;
        .btn {
            width: 100%;
            @media (min-width: 576px) {
                max-width: 432px;
            }
        }
    }
`;

const AddCategoryModal = ({onClose}) => {
    const [form] = useForm();
    const [itemForm] = useForm();
    const [required, setRequired] = useState(false);
    const [selectMultiple, setSelectMultiple] = useState(null);
    const [items, setItems] = useState([]);

    function handleItemSubmit(e) {
        setItems(prev => [...prev, e?.itemName]);
    }
    function handleCategorySubmit(e) {
        onClose();
    }
    return (
        <StyledAddCategoryModal>
            <Form form={form} onSubmit={handleCategorySubmit}>
                <Form.Item
                    label="Category Name"
                    $bgWhite
                    type="text"
                    name="categoryName"
                    placeholder="Enter category name here (e.g., Main, Side)"
                    rules={[
                        {
                            required: true,
                            message: "Category Name is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <h4 className="label">Required?</h4>
                <ul className="tabs-wrap">
                    <li className={required === true ? "active" : ""} onClick={() => setRequired(true)}>
                        Required
                    </li>
                    <li className={required === false ? "active" : ""} onClick={() => setRequired(false)}>
                        Optional
                    </li>
                </ul>
                <h4 className="label">Selection Type</h4>
                <ul className="tabs-wrap">
                    <li className={selectMultiple === false ? "active" : ""} onClick={() => setSelectMultiple(false)}>
                        Select 1
                    </li>
                    <li className={selectMultiple === true ? "active" : ""} onClick={() => setSelectMultiple(true)}>
                        Select multiple
                    </li>
                </ul>
            </Form>
            <Form form={itemForm} onSubmit={handleItemSubmit} className="item-form">
                <Form.Item
                    label="Add Items"
                    $bgWhite
                    type="text"
                    name="itemName"
                    placeholder="Item Name"
                    noMargin
                    rules={[
                        {
                            required: true,
                            message: "Item Name is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <Button width="126px">
                    <IoAdd color="white" size={22} />
                    Add Item
                </Button>
            </Form>
            <Form form={form} onSubmit={handleCategorySubmit}>
                <strong className="title">Current Items:</strong>
                {items?.length > 0 && (
                    <ul className="items-list">
                        {items?.map((data, index) => (
                            <li key={index}>
                                <IoCloseCircle
                                    color="rgba(224, 0, 0, 1)"
                                    size={20}
                                    cursor="pointer"
                                    onClick={() => setItems(prev => prev.filter((_, i) => i !== index))}
                                />
                                {data}
                            </li>
                        ))}
                    </ul>
                )}
                <div className="btn-holder">
                    <Button className="btn">Save</Button>
                </div>
            </Form>
        </StyledAddCategoryModal>
    );
};

export default AddCategoryModal;
